import { motion } from "framer-motion";
import { Check, ShoppingCart, Star } from "lucide-react";

const JAR =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_82d11e62-96d8-4a58-bd86-23180e6879b5/artifacts/y4cty4ct_WhatsApp%20Image%202026-08-13%20at%207.57.24%20AM.jpeg";
const TUBE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_82d11e62-96d8-4a58-bd86-23180e6879b5/artifacts/31b00jwv_WhatsApp%20Image%202026-08-13%20at%207.57.24%20AM%20%281%29.jpeg";

const products = [
  {
    id: "jar",
    name: "Healseeal Jar",
    tag: "1000g · Multi-Use Balm",
    img: JAR,
    price: "₹2,212",
    unit: "/ 1000g",
    desc: "A rich bioactive balm for larger surface areas and chronic wound care. Ideal for clinical and home-care routines.",
    points: ["Seals in 12 seconds", "Deep bioactive layer", "Complete heal in 24h"],
  },
  {
    id: "tube",
    name: "Healseeal Tube",
    tag: "50g · Precision Gel",
    img: TUBE,
    price: "On Enquiry",
    unit: "",
    desc: "A precision applicator gel for cuts, abrasions and post-procedure wounds. Forms a breathable protective micro-seal on contact.",
    points: ["Seals in 12 seconds", "Non-sticky finish", "Portable applicator"],
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 60 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.15 },
  }),
};

export const Products = () => (
  <section id="products" className="py-24 md:py-32 relative" data-testid="products-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mb-14 max-w-2xl"
      >
        <span className="font-monotech text-xs tracking-[0.25em] uppercase text-secondary-foreground/70">
          Our Products
        </span>
        <h2 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none text-primary mt-4">
          Two formats.<br />One promise to heal.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {products.map((p, i) => (
          <motion.div
            key={p.id}
            custom={i}
            variants={cardVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="group border border-border bg-card rounded-3xl overflow-hidden hover:shadow-2xl transition-[box-shadow,transform] duration-300 hover:-translate-y-1 flex flex-col"
            data-testid={`product-card-${p.id}`}
          >
            <div className="relative h-[360px] md:h-[420px] overflow-hidden bg-gradient-to-br from-secondary/25 via-secondary/5 to-primary/10">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,rgba(235,184,80,0.35),transparent_60%)]" />
              <img
                src={p.img}
                alt={p.name}
                className="relative z-10 w-full h-full object-contain p-8 transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-5 left-5 z-20 font-monotech text-[10px] tracking-widest uppercase bg-primary text-white px-3 py-1.5 rounded-full">
                {p.tag}
              </span>
            </div>
            <div className="p-7 md:p-8 flex flex-col flex-1">
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-heading font-bold text-2xl sm:text-3xl tracking-tight text-primary">
                  {p.name}
                </h3>
                <div className="text-right shrink-0">
                  <div className="font-heading font-extrabold text-2xl text-clinic leading-none" data-testid={`product-price-${p.id}`}>
                    {p.price}
                  </div>
                  {p.unit && <div className="font-monotech text-[10px] text-text-muted mt-1">{p.unit}</div>}
                </div>
              </div>
              <a href="#reviews" className="mt-2 inline-flex items-center gap-1.5 w-fit" data-testid={`product-rating-${p.id}`}>
                <span className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-secondary text-secondary" />
                  ))}
                </span>
                <span className="text-xs text-text-muted font-medium hover:text-primary transition-colors">4.9 · Trusted by clinicians</span>
              </a>
              <p className="mt-3 text-text-muted leading-relaxed">{p.desc}</p>
              <ul className="mt-6 flex flex-wrap gap-3">
                {p.points.map((pt) => (
                  <li
                    key={pt}
                    className="flex items-center gap-1.5 text-sm font-medium text-primary bg-muted px-3 py-1.5 rounded-full"
                  >
                    <Check className="w-3.5 h-3.5 text-clinic" /> {pt}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`order-now-${p.id}`}
                className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-primary text-white h-12 px-8 text-sm font-semibold hover:bg-accent transition-colors duration-300 w-full sm:w-auto"
              >
                <ShoppingCart className="w-4 h-4" /> Order Now
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
